import ImagePreloader from "./ImagePreloader";
import Vue from 'vue'
import UnexLib from "./UnexLib";
import translations from "./translations/translations.json"
import $ from 'jquery'
import { query } from './query.js'
import { entities } from './entities.js'
import { api } from './api.js'

export class application {

    constructor() {
        var App = this

        this.apiUrl = "https://xr17.unex.net/soluciones/api/public"

        // User
        this.user = {
            name: "user name",
            markets: [],
            languages: [],
            scopes: [],
            default_language: 'en'
        };
        this.initialized = false;

        this.loaded_components = {};
        this.ready_functions = [];
        this.selected_language = null;
        this.current_translations = {};
        this.debug = false;
        this.image_preloader = new ImagePreloader();
        this.enable_loader = true;

        // Language and market
        this.translations = translations;

        this.selected_market_solutions = 0;
        this.selected_language = 'es';
        this.selected_language_solutions = 'es';
        this.setLanguage(this.getBrowserLanguage());

        // from app.js
        this.bus = new Vue()
        this.entities = new entities(this)
        this.query = new query(this)
        this.api = new api(this)

        // globals
        this.active_view = null;
        this.loading_activated = false;
        this.root_activated_view = 'query_filters'; // single_application_solution'; // 'query_filters'; //'dashboard'; //
        this.current_query = {};
        this.is_new_query = true;
        this.current_category_filter_selected = '';
        this.applications_solutions_group = [];
        this.id_selected_obra = null;
        this.id_selected_solution = null;

        this.auth_returl_url = null


        // from app.vue
        this.current_query = {}
        this.lateral_menu_items = [
            {
                name: 'dashboard',
                value: 'dashboard',
                icon: 'icon-dashboard',
                hasView: true,
                in_views: ['query_filters', 'application_solutions']
            },
            {
                name: 'dashboard-disabled',
                value: 'dashboard-disabled',
                icon: 'icon-dashboard',
                hasView: false,
                in_views: ['dashboard']
            },
            {
                name: 'market',
                value: 'market',
                tooltip: 'market',
                icon: 'icon-market-display',
                hasView: false,
                in_views: ['query_filters'],
                fnc: 'openMarketModal'
            },
            {
                name: 'market-disabled',
                value: 'market-disabled',
                tooltip: 'market',
                icon: 'icon-market-display',
                hasView: false,
                in_views: ['application_solutions']
            },
            {
                name: 'language',
                value: 'language',
                tooltip: 'language',
                icon: 'icon-language-display',
                hasView: false,
                in_views: ['query_filters', 'application_solutions'],
                fnc: 'openLanguageModal'
            },
            {
                name: 'user',
                value: 'user_profile',
                icon: 'icon-user-display',
                hasView: false,
                in_views: ['dashboard'],
                fnc: 'openPanelProfile'
            },
            {
                name: 'query_details',
                value: 'query_details',
                icon: 'icon-query-details',
                hasView: false,
                in_views: ['application_solutions', 'single_application_solution'],
                fnc: 'openPanelQueryDetails'
            }
        ]
    }

    async init() {
        if( this.initialized ) return;

        console.warn("App init")
        try {
            await this.getUserData()

        } catch (error) {
            return false;
        }


        var unex_lib_object = {
            url: this.apiUrl,

            // TODO: @remove
            // username: this.email,
            // password: this.password,
            // client_id: 3,
            // client_secret: "UvyzrgzMoaTdTMg59cm6PSel2F4VtCp7WJD8rKAV",

            onError: (function () {
                // TODO: controlar millor
                alert('error unexlib')
                return;
            }).bind(this),

            onLoaded: function () {
                // clearInterval(checkConnection);
                sessionStorage.is_admin = true;
                // document.location.href = './unex_app.html';
            }
        }

        this.unex_lib = new UnexLib(unex_lib_object)

        // TODO: queries guardades
        //Loading saved queries
        // obj.saved_queries = {
        //     own: [],
        //     market: []
        // };
        // for (var i in obj.user.markets) {
        //     obj.saved_queries.own[obj.user.markets[i]] = obj.getStoredQueries(obj.user.markets[i]);
        //     obj.saved_queries.market[obj.user.markets[i]] = obj.getStoredMarketQueries(obj.user.markets[i]);
        // }

        // Inicialitzar query/filtres
        await this.entities.init();
        this.query.init();

        this.initialized = true;

    }
    async getUserData(){
        this.user = await this.api.get('/user')
        this.selected_language_solutions = this.user.default_language_solutions;
        this.selected_market_solutions = this.user.default_market;
    }
    disableLoader() {
        this.enable_loader = false;
    }

    log() {
        if (this.debug) console.log(arguments);
    }

    preloader() {
        return this.image_preloader;
    }

    getBrowserLanguage = function () {
        var navigator_language = (navigator.language || navigator.userLanguage);
        if (navigator_language === "es-CL") {
            navigator_language = "cl";
        }
        if (navigator_language.substring(0, 2) === "ca") {
            navigator_language = "es";
        } else {
            navigator_language = navigator_language.substring(0, 2);
        }
        if ((["es", "en", "cl", "de", "fr", "it", "pt"]).indexOf(navigator_language) !== -1) {
            return navigator_language;
        } else {
            return 'en';
        }
    }

    setLanguage(language) {
        this.selected_language = language;
        this.selected_language_solutions = language;

        Object.keys(this.translations).map((function (key) {
            if (this.current_translations[key] === undefined) this.current_translations[key] = {};

            Object.keys(this.translations[key]).map((function (key_trans) {
                this.current_translations[key][key_trans] = this.translations[key][key_trans][this.selected_language];
            }).bind(this));

        }).bind(this));
    }

    setMarket(market) {
        this.selected_market = market;
        this.selected_market_solutions = market;
    }

    showLoader(times, fnc_post, obj, fnc_on_load) {
        var obj_clone;
        if (obj === undefined) obj_clone = {};
        else obj_clone = JSON.parse(JSON.stringify(obj));
        this.bus.$emit('show_loader', times, fnc_on_load);
        setTimeout((function (obj) {
            return (function () { fnc_post(obj) });
        })(obj_clone), 10);
    }
    showSpinner() {
        $('#loading_wrapper').show();
    }
    hideSpinner() {
        $('#loading_wrapper').hide();
    }
    filterInCurrentView(lateral_menu_items, currentView) {
        var obj = [];
        for (var i = 0; i < lateral_menu_items.length; i++) {
            var result = lateral_menu_items[i].in_views.filter(
                function (item) {
                    return item == currentView;
                }
            ).length;
            if (result > 0) {
                obj.push(lateral_menu_items[i]);
            }
        }
        return obj;
    }

}
const App = new application()
export default App;